/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import MobileConsumption from '../../../../components/MobileConsumption';
import navigateParams from '../../../../utils/navigation/navigateParams';
import './index.scss';
import { formatMobileNumber } from '../../../../utils/dataTransformation/unitsConversion';
import { useDispatch } from 'react-redux';
import { showStopper } from '../../../../utils/store/features/user';
import { TrackingEvents } from '../../../../utils/dataTransformation/tracking';
import { isWebviewAndroid, isWebviewIOS } from '../../../../utils/navigation/controlDevices';
import { managementEnvironment } from '../../../../utils/dataTransformation/environments';
import Stopper from '../../../../components/Stopper';

const MobileConsumptionPage: React.FC = () => {
    const [searchParams] = useSearchParams();
    const [typeClicked, setTypeClicked] = useState(null);
    const dispatch = useDispatch();
    const { trackingScreenView } = new TrackingEvents();
    const navigate = useNavigate();
    const [storageJson, setStorageJson] = useState<any>();
    const [number, setNumber] = useState('600000000');
    const storage = localStorage.getItem('storage');

    useEffect(() => {
        if (storage && storage !== 'undefined') {
            const tempStorageJson = JSON.parse(storage ?? '');
            setStorageJson(tempStorageJson);
            if (tempStorageJson.data) {
                setNumber(tempStorageJson.number);
            }
        }
    }, [storage]);

    const consumptionsDisabled = managementEnvironment().VITE_STOPPER_CONSUMPTIONS_DISABLED;
    const homeDisabled = managementEnvironment().VITE_STOPPER_HOME_DISABLED;

    useEffect(() => {
        if (!(isWebviewAndroid || isWebviewIOS)) {
            trackingScreenView();
        }
    }, []);

    const sendToNative = (detailType: any) => {
        if (consumptionsDisabled) {
            dispatch(showStopper());
        } else {
            const productPsId = searchParams.get('productPsId');
            const type = 'modeFlow-backgroundBlue';
            const title = 'Detalle de consumo';
            const url = '/mobile/consumption';
            const queryParams = { productPsId: productPsId };
            storageJson.data.detailType = detailType;
            storageJson.data.isMobile = true;
            if (navigateParams(type, url, queryParams, storageJson, title)) {
                navigate(url + '?productPsId=' + productPsId);
            }
        }
    };

    return homeDisabled ? (
        <Stopper></Stopper>
    ) : (
        <div className='consumption-page'>
            <div className='consumption-page__mobile'>
                <MobileConsumption
                    mobileNumber={formatMobileNumber(number)}
                    data={storageJson}
                    navigate={sendToNative}
                    typeClicked={setTypeClicked}
                ></MobileConsumption>
            </div>
        </div>
    );
};

export default MobileConsumptionPage;
